import { Component, computed, effect, input, OnInit, output, signal } from '@angular/core';
import { IncidentService } from '../../shared/incident.service';
import { NotificationService } from '../../shared/notification.service';
import { AppModule } from '../../app.module';
import { Incident } from '../../models/incident';
import { IncidentStatusCategory } from '../../shared/enums';

@Component({
  selector: 'app-incident-search',
  imports: [AppModule],
  templateUrl: './incident-search.html',
  styleUrl: './incident-search.less'
})
export class IncidentSearch {

  searchTerm = input<string>('');
  dateRange = input<[Date, Date] | null>(null);
  
  searchTermChange = output<string>();
  dateRangeChange = output<[Date, Date] | null>();
  clearFilters = output<void>();

  constructor() { }

   public onSearchTermChange(value: string) {
    this.searchTermChange.emit(value);
  }

  public onDateRangeChange(value: [Date, Date] | null) {
    this.dateRangeChange.emit(value);
  }

  public onClearFilters() {
    this.clearFilters.emit();
  }
}
